/* 
  Verified High-Quality Fashion Assets for WardrobeWave
  All URLs point to professional fashion photography on Unsplash
*/

export const closetItems = [
  { 
    id: '1', 
    type: 'top', 
    name: 'Silk Drapery Blouse', 
    brand: 'Céline', 
    color: 'Cream', 
    tags: ['formal', 'silk', 'minimal'], 
    image: 'https://images.unsplash.com/photo-1581044777550-4cfa60707c03?w=800&q=80', 
    wornCount: 12, 
    value: 450 
  },
  { 
    id: '2', 
    type: 'bottom', 
    name: 'Pleated Wool Trousers', 
    brand: 'The Row', 
    color: 'Graphite', 
    tags: ['office', 'tailored', 'staple'], 
    image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=800&q=80', 
    wornCount: 24, 
    value: 890 
  },
  { 
    id: '3', 
    type: 'outerwear', 
    name: 'Heritage Trench Coat', 
    brand: 'Burberry', 
    color: 'Honey', 
    tags: ['classic', 'rain', 'autumn'], 
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&q=80', 
    wornCount: 8, 
    value: 1200 
  },
  { 
    id: '4', 
    type: 'shoes', 
    name: 'Chelsea Boots', 
    brand: 'Saint Laurent', 
    color: 'Black', 
    tags: ['winter', 'leather', 'evening'], 
    image: 'https://images.unsplash.com/photo-1608256246200-53e635b5b65f?w=800&q=80', 
    wornCount: 15, 
    value: 950 
  },
  { 
    id: '5', 
    type: 'accessory', 
    name: 'Quilted Chain Bag', 
    brand: 'Chanel', 
    color: 'Black', 
    tags: ['evening', 'luxury', 'iconic'], 
    image: 'https://images.unsplash.com/photo-1584916201218-f4242ceb4809?w=800&q=80', 
    wornCount: 5, 
    value: 3200 
  },
  { 
    id: '6', 
    type: 'top', 
    name: 'Cashmere Mockneck', 
    brand: 'Khaite', 
    color: 'Heather Grey', 
    tags: ['winter', 'cashmere', 'knit'], 
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&q=80', 
    wornCount: 18, 
    value: 720 
  },
  { 
    id: '7', 
    type: 'bottom', 
    name: 'Straight Leg Denim', 
    brand: 'Levi\'s Made & Crafted', 
    color: 'Vintage Indigo', 
    tags: ['casual', 'denim', 'daily'], 
    image: 'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=800&q=80', 
    wornCount: 42, 
    value: 110 
  },
  { 
    id: '8', 
    type: 'shoes', 
    name: 'Achilles Low Sneakers', 
    brand: 'Common Projects', 
    color: 'White', 
    tags: ['casual', 'minimal', 'leather'], 
    image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=800&q=80', 
    wornCount: 30, 
    value: 410 
  },
];

export const capsules = [
  { 
    id: 'c1', 
    name: 'Copenhagen Winter', 
    itemsCount: 14, 
    status: 'Active', 
    image: 'https://images.unsplash.com/photo-1445205170230-053b830c6039?w=400&q=80' 
  },
  { 
    id: 'c2', 
    name: 'Milan Business', 
    itemsCount: 9, 
    status: 'Draft', 
    image: 'https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?w=400&q=80' 
  }
];

export const todayOutfit = {
  id: 'o1',
  name: 'Rainy City Utilitarian',
  notes: 'Trench coat added due to 40% precipitation forecast. Boots for practical commute.',
  items: ['6', '7', '3', '8'],
  mood: 'Architectural'
};

export const upcomingEvents = [
  { id: 'e1', date: 'Tomorrow', name: 'Design Review', outfitStatus: 'Planned', type: 'Office' },
  { id: 'e2', date: 'Friday', name: 'Weekend in Paris', outfitStatus: 'In Progress', type: 'Travel' },
  { id: 'e3', date: 'Sunday', name: 'Gallery Brunch', outfitStatus: 'Empty', type: 'Casual' },
];

export const wishlist = [
  { id: 'w1', name: 'Oversized Blazer', brand: 'Ami Paris', price: '$650', image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?w=300&q=80' },
  { id: 'w2', name: 'Horsebit Loafers', brand: 'Gucci', price: '$920', image: 'https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=300&q=80' }
];